import React from 'react';
import InputField from 'sub_components/Common/BloxTextInput';
import { INPUT_TYPES, numberMask } from 'utils/Misc/CommonConstants';
import { Utils } from 'services/utils';
import { Filter } from 'styled_components/Common/Filter';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const deleteVipDefault = `${CDN_URL}storage/delete-vip-default-lg.svg`;
const deleteVipHover = `${CDN_URL}storage/delete-vip-hover-lg.svg`;
let bypassIpUpdate = false;

const formatIpString = index => {
	const oct1 = document.querySelector(`.ip_field_quarter_${index}_quad0`).value;
	const oct2 = document.querySelector(`.ip_field_quarter_${index}_quad1`).value;
	const oct3 = document.querySelector(`.ip_field_quarter_${index}_quad2`).value;
	const oct4 = document.querySelector(`.ip_field_quarter_${index}_quad3`).value;

	const subnet = document.getElementById(`filter-title-${index}`).innerText;

	return `${oct1}.${oct2}.${oct3}.${oct4}/${subnet}`;
};

const onChange = (index, addIp) => event => {
	const { nativeEvent: { data } = {} } = event;

	if (/subnet/.test(event.target.name)) {
		toggleSubnetStatus(event.target.value, index);
	}

	if (parseInt(data) || data === '0' || data === null || !bypassIpUpdate) {
		const { name: elementUpdated } = event.target;
		const ipStr = formatIpString(index);

		if (ipStr) {
			addIp(index, ipStr, elementUpdated);
		}
	}

	if (bypassIpUpdate) {
		bypassIpUpdate = false;
	}
};

const onKeyDown = index => event => {
	const { key } = event;
	const activeEl = document.activeElement;
	let currentInput = 0;

	/** Get the ip input index of the index currently in focus */
	if (activeEl && activeEl.nodeName === 'INPUT' && activeEl.classList[0]) {
		const className = activeEl.classList[0];
		const matches = className.match(/ip_field_quarter_[\d]+_quad([\d]+)/);
		if (matches && matches[1] && parseInt(matches[1])) {
			currentInput = parseInt(matches[1]);
		}
	}

	if (key === '.') {
		const nextInput = document.querySelector(`.ip_field_quarter_${index}_quad${currentInput + 1}`);
		if (currentInput < 4 && nextInput) {
			setTimeout(() => {
				nextInput.focus();
			}, 100);
		}
		bypassIpUpdate = true;
	} else if (key === '/') {
		const subnetInput = document.querySelector(`.subnet-${index}`);
		if (currentInput !== 4 && subnetInput) {
			subnetInput.focus();
		}
		bypassIpUpdate = true;
	}
};

const toggleSubnetStatus = (subnet, index) => {
	const subnetEl = document.getElementById(`filter-title-${index}`);
	const isValid = Utils.checkSubnetValidity(subnet);
	if (!isValid) {
		subnetEl.classList.remove('valid');
		subnetEl.classList.add('invalid');
	} else {
		subnetEl.classList.remove('invalid');
		subnetEl.classList.add('valid');
	}
};

const onSubnetSelect = (index, addIp) => subnet => {
	const subnetEl = document.getElementById(`filter-title-${index}`);

	if (subnet && subnetEl) {
		subnetEl.innerText = subnet;
		const ipStr = formatIpString(index);
		if (ipStr) {
			toggleSubnetStatus(subnet, index);
			addIp(index, ipStr);
		}
	}
};

const generateSubnetOptions = pieces => {
	const subnets = ['32', '30', '28', '26', '24', '14'];
	const validSubnets = [];

	subnets.forEach(subnet => {
		const ipStr = pieces.join('.');
		const cidrStr = `${ipStr}/${subnet}`;
		const { validity: isValid } = Utils.checkIsValidNetworkId(cidrStr);
		if (isValid) {
			validSubnets.push(subnet);
		}
	});

	return validSubnets;
};

const renderInputFields = (ipPieces, ipIndex, addIp, customClass, dirty) => {
	const inputFields = [];
	const dirtyIndex = ipIndex - 1;
	let validityClass;

	for (let i = 0; i < 4; i++) {
		/** If octect has been touched, determine validity */
		if (dirty[dirtyIndex]) {
			if (dirty[dirtyIndex][i]) {
				validityClass =
					ipPieces[i] === 0 || (ipPieces[i] && ipPieces[i] >= 0 && ipPieces[i] < 256)
						? 'valid'
						: 'invalid';
			} else {
				validityClass = 'unset';
			}
		} else {
			validityClass = 'unset';
		}

		inputFields.push(
			<>
				<InputField
					key={`${ipIndex}-${i}`}
					// key={`${ipPieces ? ipPieces.join('.') : 'empty'}`}
					type={INPUT_TYPES.INPUT}
					placeholder='1'
					label=''
					name={`ip_field_quarter_${ipIndex}_quad${i}`}
					cypressId={`${ipIndex}-${i}`}
					mask={numberMask}
					value={ipPieces[i]}
					onChange={onChange(ipIndex, addIp)}
					onKeyDown={onKeyDown(ipIndex)}
					active
					hideCheckmark
					customClass={`${validityClass} ${customClass}`}
				/>
				{i !== 3 && <div className='input-dot'>.</div>}
			</>,
		);
	}

	return inputFields;
};

const WhiteListRowNew = ({
	index,
	ip,
	dirty,
	addIp,
	removeIp,
	empty,
	customClass,
	state,
	single,
}) => {
	const { pieces, subnet } = Utils.splitIp(ip);
	const { validity: isValid, msg } = Utils.checkIpValidity(pieces, subnet, dirty[index - 1]);
	let validity = isValid;
	const errors = [
		<div key={`${ip}-error-${msg}`} className='error'>
			{msg}
		</div>,
	];
	const subnetOptions = generateSubnetOptions(pieces);

	if (ip && pieces.every(piece => parseInt(piece) || piece === 0)) {
		const ipStr = pieces.join('.');
		const cidrStr = `${ipStr}/${subnet || 32}`;
		const { validity: validCidr, msg: cidrErr } = Utils.checkIsValidNetworkId(cidrStr);

		errors.push(
			<div key={`${ip}-cidr-error-${cidrErr}`} className='error'>
				{cidrErr}
			</div>,
		);
		validity = isValid && validCidr;
	}
	const errDiv = <div className='ip-error body-copy-small-regular'>{errors}</div>;
	console.log(validity);

	return (
		<>
			<div
				className={`white-list-row ${empty ? 'empty' : ''} ${state === '0' ? 'provisioning' : ''}`}
			>
				{state === '0' && <div className='provisioning'>PROVISIONING</div>}
				<div id={`white-list-row-${index}`} className='ip'>
					{renderInputFields(pieces, index, addIp, customClass, dirty)}
					<div className='slash'>/</div>
					<div className='whitelist-dd'>
						<Filter
							module='storage'
							className='xs'
							id={`ip_field_subnet subnet-${index}`}
							selected={subnet ? subnet : '32'}
							options={subnetOptions}
							callback={onSubnetSelect(index, addIp)}
							filterHeading=''
							index={index}
						/>
					</div>
					{!single && (
						<div className='delete-white-list'>
							<img
								src={deleteVipDefault}
								id={`whitelist-${index}delete`}
								className='vip-button'
								data-cy={`whitelist-${index}-delete`}
								onMouseOver={e => {
									e.currentTarget.src = deleteVipHover;
								}}
								onMouseOut={e => {
									e.currentTarget.src = deleteVipDefault;
								}}
								onClick={() => removeIp(index)}
							/>
						</div>
					)}
				</div>
			</div>
			{errDiv}
		</>
	);
};

export default WhiteListRowNew;
